export enum TeamProfileTab {
    Settings,
    Access,
    Activity,
    Permissions,
    Delete
}
